import React from 'react';
import { Input } from '../';
import { Icon } from '../..';
import './input-search.scss';
export var InputSearch = function (_a) {
    var id = _a.id, onKeyUp = _a.onKeyUp, setValue = _a.setValue, value = _a.value;
    return (React.createElement("div", { className: "c-input-search" },
        React.createElement(Icon, { name: "search" }),
        React.createElement(Input, { type: "text", id: id, placeHolder: "Search", onKeyUp: onKeyUp, setValue: setValue, value: value })));
};
